import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Input, Icon, Tag, Select, InputNumber, TreeSelect } from 'antd';
import { Label, Refer } from '../basic';
import ReferModal from '../refer';
import * as formulaActions from '../../redux/formula';

const TextArea = Input.TextArea;

class Operator extends Component {
  render() {
    const { dataSource } = this.props;
    if (!dataSource || !dataSource.length)
      return null;
    const items = [];
    dataSource.forEach(item => {
      const { key, value } = item;
      items.push(<Tag key={key} onClick={() => this.props.onClick(key)}>{value}</Tag>);
    });
    return (
      <div>{items}</div>
    );
  }
}

//参照返回字段
class Selectrefercode extends Component {
  render() {
    let returnvalue = this.props.returnvalue;
    const options = [];
    const Option = Select.Option;
    if (!returnvalue) {
      return null;
    }
    returnvalue.forEach(function (ele) {
      let referitem = (<Option key={ele.cName}>{ele.cShowCaption}</Option>)
      options.push(referitem)
    })
    return (<Select value={this.props.defaultrefer} onChange={(value) => this.props.selectrefer(value)}>{options}</Select>)
  }
}

//参照ID
class ReferInput extends Component {
  constructor(props) {
    super(props);
    let name = ''
    if (this.props.editreferid) {
      name = this.props.editreferid
    }
    //构建参照模型
    this.referModel = new cb.models.ReferModel({ cRefType: 'pub_refList', refReturn: 'code', value: name, displayname: 'name' });
  }

  componentDidMount() {
    let self = this;
    let codeValue = "";
    let newname = this.props.editreferid
    let referValue = this.referModel.getValue();
    this.referModel.on('afterValueChange', function () {
      codeValue = this.getValue()
      self.props.getValue(codeValue)
    })
    this.referModel.browse(false, function (vm) {
      vm.on('getRefMetaReady', function () {
        if (!referValue) {
          if (referValue === null)
            this.referModel.setValue(referValue);
          return;
        }
        var condition = {
          'isExtend': true,
          simpleVOs: [{ field: 'code', op: 'eq', value1: newname }]
        };
        vm.execute('pressEnter', { model: this.referModel, value: newname, browse: false });
      });
    });
  }
  render() {
    return (<Refer model={this.referModel} />)
  }
}

class RightContent extends Component {
  constructor(props) {
    super(props);
    this.state = { defaultrefer: '', codeId: '', returnval: [] };
  }
  componentDidMount() {
    this.props.formulaActions.initOperator();
  }
  onCaptionChange = (e) => {
    this.props.formulaActions.changeCaption(e.target.value);
  }
  onChange = (e) => {
    this.props.formulaActions.change(e.target.value, e.target.selectionStart);
  }
  onFocus = () => {
    setTimeout(() => {
      const input = findDOMNode(this.input);
      this.props.formulaActions.focus(input.selectionStart);
    }, 0);
  }
  handleOperatorSelect = (key) => {
    this.props.formulaActions.selectOperator(key);
  }
  getControl(control, caption, required) {
    const title = required ? <label><Icon type='star' />{caption}</label> : <label>{caption}</label>;
    return (
      <Label control={control} title={title} />
    );
  }
  getFormatControl = () => {
    const { cControlType, cFormatData } = this.props.formula;
    let controlType = cControlType && cControlType.trim().toLocaleLowerCase();
    if (controlType == 'input') return null;
    if (controlType == 'datepicker') {
      return (
        <Input placeholder="例：YYYY-MM-DD HH:mm:ss" value={cFormatData} onChange={this.onFormatChange} />
      )
    }
    if (controlType == 'inputnumber') {
      let monovalentdecimal = {}, amountofdecimal = {}, quantitydecimal = {};
      monovalentdecimal.decimal = "<%option.monovalentdecimal%>";
      amountofdecimal.decimal = "<%option.amountofdecimal%>";
      quantitydecimal.decimal = "<%option.quantitydecimal%>";
      return (
        <Select value={cFormatData} onChange={this.onFormatChange}>
          <Select.Option value={JSON.stringify(monovalentdecimal)}>单价精度</Select.Option>
          <Select.Option value={JSON.stringify(amountofdecimal)}>金额精度</Select.Option>
          <Select.Option value={JSON.stringify(quantitydecimal)}>数量精度</Select.Option>
        </Select>
      )
    }
    return null;
  }
  onFormatChange = (e) => {
    this.props.formulaActions.setCommonData({ 'cFormatData': e.target ? e.target.value : e });
  }
  onFieldTypeChange = (value) => {
    this.props.formulaActions.setCommonData({ 'cControlType': value, 'cFormatData': null, 'iNumPoint': 0 });
    if (value === 'select' || value === 'refer') {
      this.props.formulaActions.chooseEnumService(value);
    }
  }
  onNumPointChange = (value) => {
    this.props.formulaActions.setCommonData({ 'iNumPoint': value });
  }
  getDataTypeControl = () => {
    const { custom, cControlType, bCanModify } = this.props.formula;
    let controlType = cControlType && cControlType.trim().toLocaleLowerCase();
    let controlArr = [];
    if (custom.enums && bCanModify) {
      // if () {
        Object.getOwnPropertyNames(custom.enums).map((pname) => {
          controlArr.push(<Select.Option value={pname.toLocaleLowerCase()}>{custom.enums[pname]}</Select.Option>);
        })
      // } else {
      //   Object.getOwnPropertyNames(custom.enums).map((pname) => {
      //     if (pname.toLocaleLowerCase() === controlType) {
      //       controlArr.push(<Select.Option value={pname.toLocaleLowerCase()}>{custom.enums[pname]}</Select.Option>);
      //     }
      //   })
      // }
      return (
        <Select value={controlType} onChange={this.onFieldTypeChange}>
          {controlArr}
        </Select>
      )
    }

    if(!bCanModify && controlType==='refer'){
      controlType='input';
      this.onFieldTypeChange(controlType);
    }
    return (
      <Select value={controlType} onChange={this.onFieldTypeChange}>
        <Select.Option value="input">文本</Select.Option>
        <Select.Option value="inputnumber">数值</Select.Option>
        <Select.Option value="datepicker">日期</Select.Option>
        <Select.Option value="select">枚举</Select.Option>
      </Select>
    )

  }

  getValue(value) {
    if (value == null) {
      this.props.formulaActions.setCustomVal({ "returnval": [], "defaultrefer": "", "codeId": value });
    }
    this.props.formulaActions.getreferdata(value)
    this.props.formulaActions.setCustomVal({ "codeId": value });
  }

  enuonchang = (val) => {
    this.props.formulaActions.setCustomVal({ "enumval": val });
  }

  selectrefer(changevalue) {
    this.props.formulaActions.setCustomVal({ "defaultrefer": changevalue, });
  }

  getEnumControl = () => {
    const { custom } = this.props.formula;
    if (!custom.data || !custom.data.length || custom.data.length == 0) return null;
    const TreeNode = TreeSelect.TreeNode;
    let controlArr = [];
    custom.data.map((item) => {
      controlArr.push(<TreeNode className="enumtree" key={item.description} title={item.description} value={item.enumtype} />);
    });
    return <TreeSelect
      showSearch
      style={{ width: 300 }}
      value={custom.enumval}
      dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
      placeholder="请选择"
      allowClear
      treeDefaultExpandAll
      onChange={(value) => this.enuonchang(value)}>
      {controlArr}
    </TreeSelect>;
  }

  render() {
    const { operatorData, caption, expression, errorInfo, cControlType, iNumPoint, cFormatData, visible, custom } = this.props.formula;
    if (!visible) {
      if (custom.enums) {
        this.props.formulaActions.clearEnumData();
      }
    }
    const columnNameCom = <Input value={caption} onChange={this.onCaptionChange} />
    const operatorCom = <Operator dataSource={operatorData} onClick={this.handleOperatorSelect} />
    const expressionCom = <TextArea ref={node => this.input = node} onFocus={this.onFocus} value={expression} onChange={this.onChange} />
    let controlType = cControlType && cControlType.trim().toLocaleLowerCase();
    const fieldTyepControl = this.getDataTypeControl();
    const formatControl = this.getFormatControl();
    const numPointControl = <InputNumber value={iNumPoint} onChange={this.onNumPointChange} />
    const referInput = <ReferInput model={this.fromModel} getValue={(value) => this.getValue(value)} editreferid={custom.codeId}></ReferInput>
    const selectrefercode = <Selectrefercode returnvalue={custom.returnval} selectrefer={(changevalue) => this.selectrefer(changevalue)} defaultrefer={custom.defaultrefer}></Selectrefercode>
    return (
      <div>
        {this.getControl(columnNameCom, '栏目名称', true)}
        {this.getControl(operatorCom, '运算符')}
        <div className="formula-editing">
          {this.getControl(expressionCom, '编辑区', true)}
          <label className="error">{errorInfo}</label>
        </div>
        {this.getControl(fieldTyepControl, '数据类型', true)}
        {controlType === 'select' && this.getControl(this.getEnumControl(), '枚举项', true)}
        {controlType === 'refer' && this.getControl(referInput, '参照ID', true)}
        {controlType === 'refer' && this.getControl(selectrefercode, '参照返回字段', true)}
        {formatControl ? this.getControl(formatControl, '格式化', false) : null}
        {controlType == 'inputnumber' ? this.getControl(numPointControl, '精度', false) : null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    formula: state.formula.toJS()
  }
}

function mapDispatchToProps(dispatch) {
  return {
    formulaActions: bindActionCreators(formulaActions, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RightContent);



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/formula-designer/RightContent.jsx